module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_short_front_shadow.e5c24d56.png";